import { Component, OnInit } from '@angular/core';
import { FormBuilder, FormGroup, Validators } from '@angular/forms';
import { ActivatedRoute, Params } from '@angular/router';
import { IdiomasServiceN35 } from 'app/main/wizard-n35/services/idiomas.service';
import * as backInter from 'app/auth/auth-data.model';
import { ColaboradoresService } from 'app/main/wizard-cgo/services/colaboradores.service';
import { Colaboradores35Service } from 'app/main/wizard-n35/services/colaboradores35.service';
import * as colabInter from './tasklist.interface';
///IDIOMAS
import { lang_wizard } from 'app/idiomas/i18n/wizard-guia/wizard.lang';
import { FuseTranslationLoaderService } from '@fuse/services/translation-loader.service';
import { Subject } from 'rxjs';
import {TranslateService} from '@ngx-translate/core';

@Component({
  selector: 'app-tasklist',
  templateUrl: './tasklist.component.html',
  styleUrls: ['./tasklist.component.scss']
})
export class TasklistComponent implements OnInit {
  // CG Norma 35-13
  productoCertificar: backInter.prodNorma35;
  opcTask: string[] = ['Winter', 'Spring', 'Summer', 'Autumn'];
  idiomaBanner:any;
  private _unsubscribeAll: Subject<any>;
  constructor(private formBuilder: FormBuilder,
    private _fuseTranslationLoaderService: FuseTranslationLoaderService,
    private colaboradoresService: Colaboradores35Service,
    private activated: ActivatedRoute,
    private translateSrv: TranslateService,
    private idiomasService: IdiomasServiceN35) {
      lang_wizard.forEach((locale) => {
        this._fuseTranslationLoaderService.loadTranslations(locale);
      });
      this.translateSrv.onLangChange.subscribe(() => { this.cambiaIdiomaBanner(this.translateSrv.currentLang); });
  }
  dataTasl:any;
  tittleList: any;
  IdSeccionList: any;
  AllTaskList:any;
  dataTmpPrueba : [
    {
      titutlo: any,
      idSeccion: any,
    }

  ];
  ngOnInit() {
    this.obtieneCertificarActual();
    this.cambiaIdiomaBanner(this.translateSrv.currentLang);
  }

  cambiaIdiomaBanner(idioma:string){
    this.idiomaBanner = this.translateSrv.currentLang;
    switch(idioma){
      case 'es': this.idiomaBanner = idioma;
      break;
      default: this.idiomaBanner = 'en';
    }
    this.getBanner();
  }
  urlBanner:any;
  getBanner(){
    this.urlBanner = './assets/images/norm35/'+this.idiomaBanner+'/CG Norma 35-13.png';
  }

  ArraySecciones: Array<any> = [];
  ArrayNum: Array<any> = [];
  ArrayPath: Array<any> = [];
  fechaCertificar: any;
  data:any;
  arrayTodoList: any;
  arrayTodoListTmp : Array<any> = [];
  arrayTmpList : any;
  rutaTmp: any;
  info:any;
  arregloRutas = [
    {
      path: "",
    }
  ]
  private getAllTask (fecha){
    this.data = {
      fechaDocumentador: fecha
    }
    var fechaTask;
    this.idiomasService.geTodoList(this.data).subscribe( (data : any)=>{
        this.arrayTodoList = data.secciones;

        this.colaboradoresService.getColaboradoresFastTmp(this.productoCertificar.fechaNorma35, this.productoCertificar.idNorma35)
        .subscribe( (getFast: colabInter.getBDFast) => {
          this.info=this.colaboradoresService.getinfo();
          if(this.info.level==6){
            if(getFast.message == 'Success' && getFast.numeroColaboradores > 0){
              // primeor es menos de 50 y despues más
              if(getFast.numeroColaboradores >50){

                for(let k=0; k< this.arrayTodoList.length;k++){
                  if(k!=1){
                    this.arrayTodoListTmp.push(this.arrayTodoList[k]);
                  }
                }
                this.arrayTodoList=this.arrayTodoListTmp;


              }else{
                for(let k=0; k< this.arrayTodoList.length;k++){
                  if(k!=2){
                    this.arrayTodoListTmp.push(this.arrayTodoList[k]);
                  }
                }
                this.arrayTodoList=this.arrayTodoListTmp;
              }
              for(var i=0; i < this.arrayTodoList.length; i++){
                this.getSeccion(this.arrayTodoList[i].nombreSeccion,i);
                for(var k=0; k < this.arrayTodoList[i].tareas.length; k++){
                  fechaTask=this.arrayTodoList[i].tareas[k].fechaCreacion.toString();
                  this.arrayTodoList[i].tareas[k].fechaCreacion=fechaTask.substr(2,8);
                }

              }
              //console.log("Tareas man ");
              //console.log(this.arrayTodoList)
            }
          }else{
            if(getFast.message == 'Success' && getFast.numeroColaboradores > 0){
              // primeor es menos de 50 y despues más
              if(getFast.numeroColaboradores >50){

                for(let k=0; k< this.arrayTodoList.length;k++){
                  if(k!=1){
                    this.arrayTodoListTmp.push(this.arrayTodoList[k]);
                  }
                }
                this.arrayTodoList=this.arrayTodoListTmp;


              }else{
                for(let k=0; k< this.arrayTodoList.length;k++){
                  if(k!=2){
                    this.arrayTodoListTmp.push(this.arrayTodoList[k]);
                  }
                }
                this.arrayTodoList=this.arrayTodoListTmp;
              }
              for(var i=0; i < this.arrayTodoList.length; i++){
                this.getSeccion(this.arrayTodoList[i].nombreSeccion,i);
                for(var k=0; k < this.arrayTodoList[i].tareas.length; k++){
                  fechaTask=this.arrayTodoList[i].tareas[k].fechaCreacion.toString();
                  this.arrayTodoList[i].tareas[k].fechaCreacion=fechaTask.substr(2,8);
                }

              }
              //console.log("Tareas man ");
              //console.log(this.arrayTodoList)
            }
          }

         });


        ;



    });
  }


  obtieneCertificarActual(){
    /// obtiene el producto certificar vigente
    this.colaboradoresService.getProdCertAct().subscribe((data:backInter.infoProductos) => {
      let prodsCertificar:backInter.prodNorma35[] = data.productosNorma35;
      var BreakException = {};
      try {
          prodsCertificar.forEach( (producto) => {
            let fecha = producto.fechaNorma35;
            let idProducto = producto.idNorma35;
            console.log('productoID',localStorage.getItem('productoID'));
            console.log('fechaNorma',localStorage.getItem('FechaNorma'));
            if (fecha == parseInt(localStorage.getItem('FechaNorma')) && idProducto == localStorage.getItem('productoID')) {
            if(producto.completoNorma35 === 1){
              this.productoCertificar = producto;
              this.fechaCertificar=this.productoCertificar.fechaNorma35;
              this.getAllTask(this.fechaCertificar);
              throw BreakException;

            }
          }
          });
      } catch (e) {
          if (e !== BreakException) throw e;
      };
    }, error  => {
      console.log("error al recuperar certificar vigente");
    });
  }

  private getSeccion (nombreseccion,pos){
    console.log('nombreseccion',nombreseccion);
    console.log('pos',pos);

    let pathTmp:any;
    switch(nombreseccion) {
      case "5.2 Identificar y analizar los factores de riesgo psicosocial": {
        pathTmp ="Política de prevención de riesgos psicosociales";
        this.ArrayPath[pos]="/NOM35/wizard/politica";
        this.ArraySecciones[pos]="Política de prevención de riesgos psicosociales";
        this.ArrayNum[pos]="5.1";
        break;
      }
      case "5.3 Identificar y analizar los factores de riesgo psicosocial": {
        pathTmp = "Encuesta 16-50 colaboradores";
        this.ArrayPath[pos]="/NOM35/wizard/encuesta-16-50";
        this.ArraySecciones[pos]="Encuesta 16-50 colaboradores";
        this.ArrayNum[pos]="5.2, 7.1a); 7.2; 7.4; 7.5; 7.6; 7.7; 7.8 y 7.9";
        break;
      }
      case "5.4 Adoptar las medidas para prevenir y controlar los factores de riesgo psicosocial":{
        pathTmp ="Encuesta más 50 colaboradores";
        this.ArrayPath[pos]="/NOM35/wizard/encuesta-50-mas";
        this.ArraySecciones[pos]="Encuesta más 50 colaboradores";
        this.ArrayNum[pos]="5.3, 7.1b, 7.2; 7.3; 7.4; 7.5; 7.6; 7.7; 7.8 y 7.9";
        break;
      }
      case "5.5 Identificar a los trabajadores que fueron sujetos a acontecimientos traumáticos severos":{
        pathTmp ="Medidas de prevención y control";
        this.ArrayPath[pos]="/NOM35/wizard/medidas-preventivas&control ";
        this.ArraySecciones[pos]="Medidas de prevención y control";
        this.ArrayNum[pos]="5.4; 8.1; 8.2; 8.3; 8.4 y 8.5";
        break;
      }
      case "5.6 Practicar exámenes médicos y evaluaciones psicológicas":{
        pathTmp ="Canal de quejas y denuncias";
        this.ArrayPath[pos]="/NOM35/wizard/quejas-denuncias";
        this.ArraySecciones[pos]="Canal de quejas y denuncias";
        this.ArrayNum[pos]="8.1";
        break;
      }
      case "5.1 a) La prevención de los factores de riesgo psicosocial":{
        pathTmp ="Acciones y programas preventivos";
        this.ArrayPath[pos]="/NOM35/wizard/plan-acciones";
        this.ArraySecciones[pos]="Acciones y programas preventivos";
        this.ArrayNum[pos]="8.2, 8.5";
        break;
      }
      case "5.1 b) La prevención de la violencia laboral":{
        pathTmp ="Programa de intervención con evaluaciones y medidas de control";
        this.ArrayPath[pos]="/NOM35/wizard/kpis";
        this.ArraySecciones[pos]="Programa de intervención con evaluaciones y medidas de control";
        this.ArrayNum[pos]="8.3, 8.4, 8.5";
        break;
      }
      case "5.1 c) La promoción de un entorno organizacional favorable":{
        pathTmp ="Encuesta acontecimientos traumáticos severos";
        this.ArrayPath[pos]="/NOM35/wizard/encuesta-eventos-traumáticos";
        this.ArraySecciones[pos]="Encuesta acontecimientos traumáticos severos";
        this.ArrayNum[pos]="5.5";
        break;
      }
      case "5.7 a) La política de prevención de riesgos psicosociales":{
        pathTmp="Exámenes médicos y evaluaciones psicológicas";
        this.ArrayPath[pos]="/NOM35/wizard/exámenes-médicos";
        this.ArraySecciones[pos]="Exámenes médicos y evaluaciones psicológicas";
        this.ArrayNum[pos]="5.6";
        break;
      }
      case "5.7 b) Las medidas adoptadas para combatir las prácticas opuestas":{
        pathTmp ="Difusión y promoción de información";
        this.ArrayPath[pos]="/NOM35/wizard/alteraciones-salud";
        this.ArraySecciones[pos]="Difusión y promoción de información";
        this.ArrayNum[pos]="5.7";
        break;
      }
      case "5.7 c) Las medidas y acciones de prevención y, en su caso, las acciones ...":{
        pathTmp ="Registros";
        this.ArrayPath[pos]="/NOM35/wizard/registros";
        this.ArraySecciones[pos]="Registros";
        this.ArrayNum[pos]="5.8";
        break;
      }

   }


  }





}
